const msnryVideos = document.querySelectorAll('.grid--collection .grid-product');
// const msnryVideos = Shopify.collectionMasonryVideos

$(document).ready(function(){
  if (window.matchMedia("(min-width: 769px)").matches) {
    
    const msnry = new Masonry( '.grid--collection', { itemSelector: '.grid__item' });
    
    const loadCollectionVideos = new Promise(function(resolve, reject) {
      Shopify.collectionMasonryVideos.forEach(({ index, src, thumb, title }) => {

        if (msnryVideos[index-1]) {
          msnryVideos[index-1].insertAdjacentHTML("beforebegin", `
			<div class="grid__item grid-product one-half amber" data-aos="row-of-4">
				<div class="grid-product__content msnryvideo" data-index="${index}" title="video">
<video class="video-background" loop="" muted="" no-controls="" autoplay="" src="${thumb}" playsinline="">
<source type="video/mp4" src="${thumb}">
</source></video>
				</div>
			</div>`);
        
          const newTile = document.querySelector(`[data-index="${index}"]`);
          const newVideo = newTile.querySelector(`video`);
        
          newTile.classList.add('loaded');
       
          newVideo.src = src;
        };
        
      });

      resolve('Collection videos loaded.');
    });
    
    loadCollectionVideos.then(result => {
		msnry.reloadItems();
      	msnry.layout();
    });
  }
    

$('.variant-input').click(function() {
  $(this).parent().find('.variant-input').removeClass('active')
  $(this).addClass('active') 
})

})